import styled from "styled-components";
import { useTokenStore } from "./store/TokenStore";
import { Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { Navigation } from "./components/Navigation/Navigation";
import { Login } from "./pages/Login";
import { Message } from "./components/Message/Message";
import { Sync } from "./pages/Sync";
import { Transfer } from "./pages/Transfer";
import { Registration } from "./pages/Registration";
import { Logs } from "./pages/Logs";

export const App = () => {
	const token = useTokenStore((state) => state.token);

	if (!token) {
		return (
			<>
				<Routes>
					<Route
						path="*"
						element={<h1>404 - Страница не найдена</h1>}
					/>
					<Route path="/" element={<Login />} />
					<Route path="/registracion" element={<Registration />} />
				</Routes>
				<Message />
			</>
		);
	}

	return (
		<StyledComponent>
			<div className="navigation">
				<Navigation />
			</div>
			<div className="outlet">
				<Routes>
					<Route
						path="*"
						element={<h1>404 - Страница не найдена</h1>}
					/>
					<Route path="/" element={<Home />} />
					<Route path="/sync" element={<Sync />} />
					<Route path="/transfer" element={<Transfer />} />
					<Route path="/logs" element={<Logs />} />
				</Routes>
			</div>
			<Message />
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: block;
	position: relative;
	width: 100%;
	height: 100%;

	background-color: #202634;

	& .navigation {
		width: 200px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;

		box-sizing: border-box;
	}

	& .outlet {
		padding: 1rem;

		position: absolute;
		top: 0;
		left: 200px;
		right: 0;
		bottom: 0;

		box-sizing: border-box;

		overflow-y: auto;
	}
`;
